<template>
<v-card-text>
    <v-card outlined rounded :class="this.chartClass">
        <v-card-text>
            <v-layout v-if="isShowDateFilter">
                <v-flex xs6 md6>
                    <p class="text-h6 mt-4">{{ title }}</p>
                </v-flex>
                <v-flex xs6 md6>
                    <v-select density="compact" v-model="filterOptionSelected" :items="filterOptionList" @change="toUpdateChart"></v-select>
                </v-flex>
            </v-layout>
            <v-layout v-else>
                <v-flex xs12 md12>
                    <p class="text-h6 mt-4">{{ title }}</p>
                </v-flex>
            </v-layout>
            <v-layout v-if="!loading">
                <v-flex xs12 md12>
                    <VueApexCharts :type="chartType" height="350" ref="chart" :options="chartInfo.options" :series="chartInfo.series"></VueApexCharts>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</v-card-text>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import moment from 'moment';
import colors from 'vuetify/lib/util/colors';
import formatData from "../utils/formatData";
export default {
    components: {
        VueApexCharts,
    },
    data() {
        return {}
    },
    created() {
        this.id = this.$route.params.id;
    },
    computed: {
        isShowDateFilter() {
            return this.$attrs.chartInfo.isShowDateFilter || false;
        },
        title() {
            return this.$attrs.chartInfo.title;
        },
        loading() {
            return this.$attrs.loading || false;
        },
        chartClass() {
            return this.$attrs.chartClass == undefined ? 'mt-4 ml-2' : this.$attrs.chartClass;
        },
        chartType() {
            return this.$attrs.chartInfo.chartType == undefined ? 'area' : this.$attrs.chartInfo.chartType;
        },
        filterOptionSelected: {
            get() {
                return this.$attrs.chartInfo.filterOptionSelected;
            },
            set(name) {
                return name;
            }
        },
        mod() {
            return this.$attrs.chartInfo.mod;
        },
        filterOptionList() {
            return this.$attrs.chartInfo.filterOptionList;
        },
        chartInfo() {
            let chartInfo = {
                options: {
                    title: {
                        text: '', //this.$attrs.chartInfo.chartTitle,
                        align: 'left'
                    },
                    noData: {
                        text: `no data`,
                        align: 'center',
                        verticalAlign: 'middle',
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            color: undefined,
                            fontSize: '14px',
                            fontFamily: undefined
                        }
                    },
                    xaxis: {
                        // categories: this.$attrs.chartInfo.categories,
                        labels: {
                            show: false
                        }
                    },
                }
            };

            if (!this.$attrs.chartInfo.noData) {
                let chartTitle = this.$attrs.chartInfo.chartTitle;
                chartTitle = chartTitle + " (" + this.$attrs.chartInfo.chartSubTitle + ")";

                let chartType = 'area';
                let fillChart = {
                    type: 'gradient',
                    gradient: {
                        shadeIntensity: 1,
                        inverseColors: false,
                        opacityFrom: 0.45,
                        opacityTo: 0.05,
                        stops: [20, 100, 100, 100]
                        },
                };
                let markersChart = {
                    size: 5
                };
                let plotOptions = {};
                let strokeChart = {};
                let dataLabels = {
                    enabled: false,
                    // formatter: function (val) {
                    //     return val.toFixed(1);
                    // }
                };
                let datetimeFormatter = {};
                let minX = new Date(this.$attrs.startDate).getTime();
                let maxX = new Date(this.$attrs.endDate).getTime();
                minX = undefined;
                maxX = undefined;

                if (this.$attrs.chartInfo.chartType != undefined) {
                    chartType = this.$attrs.chartInfo.chartType; //bar
                    fillChart = {};

                    if (chartType == 'line') {
                        markersChart = {
                            size: 5
                        };
                        strokeChart = {
                            width: 2
                        };
                    } 
                    else {
                        markersChart = {
                            size: 5
                        };
                        strokeChart = {
                            width: 0
                        };
                        datetimeFormatter = {
                            // year: 'yyyy',
                            // month: 'MMM \'yy',
                            day: 'dd',
                            // hour: 'HH:mm'
                        };
                        if (this.$attrs.chartInfo.mod != 'sleepData' && this.$attrs.chartInfo.mod != 'foodData') {
                            strokeChart = {
                                width: 1
                            }; 
                            fillChart = {
                                opacity: 0.4
                            };
                        }
                        dataLabels = {
                            enabled: false,
                            // offsetY: 0,
                            // textAnchor: 'middle',
                            style: {
                                fontSize: '12px',
                                colors: ["#FFF"]
                            }
                        };
                        plotOptions = {
                            bar: {
                                // columnWidth: '20%',
                                // borderRadius: 10,
                                dataLabels: {
                                    position: 'top', // top, center, bottom
                                },
                            }
                        };
                    }
                }

                let tooltip = {
                    shared: false,
                    y: {
                        show: true,
                        formatter: function (val) {
                            return val != undefined ? val.toFixed(1) : '-';
                        }
                    },
                    x: {
                        show: true,
                        format: 'dd MMM yy',
                        formatter: undefined
                    }
                };
                let chartId = 'area-datetime';
                if (this.$attrs.chartInfo.mod != undefined) {
                    chartId = this.$attrs.chartInfo.mod;
                    if (this.$attrs.chartInfo.decimal) {
                        tooltip = {
                            shared: false,
                            y: {
                                show: true,
                                formatter: function (val) {
                                    return val != undefined ? val.toFixed(0) : '-';
                                }
                            },
                            x: {
                                show: true,
                                format: 'dd MMM yy',
                                formatter: undefined
                            }
                        }
                    }
                    if (this.$attrs.chartInfo.mod == 'workoutData') {
                        tooltip = {
                            shared: false,
                            y: {
                                show: true,
                                formatter: function (val) {
                                    return val !== undefined && val > 0 ? val.toFixed(0) : '-';
                                    
                                }
                            },
                            x: {
                                show: true,
                                format: 'dd MMM yy',
                                formatter: function (val) {
                                    return val !== undefined && val > 0 ? moment(val).subtract(6, 'days').format('DD/MM/YY') + ' - ' + moment(val).format('DD/MM/YY') : '-';
                                }
                            }
                        }
                        dataLabels.enabled = true;
                    }
                }

                chartInfo = {
                    chart: chartId,
                    title: this.$attrs.chartInfo.chartTitle,
                    series: this.$attrs.chartInfo.series,
                    chartType: chartType,
                    plotOptions: plotOptions,
                    options: {
                        chart: {
                            id: chartId,
                            type: chartType,
                            stacked: false,
                            height: 350,
                            zoom: {
                                type: 'x',
                                enabled: true,
                                autoScaleYaxis: true
                            },
                            toolbar: {
                                autoSelected: 'zoom',
                                show: this.$attrs.chartInfo.toolbarShow != undefined ? this.$attrs.chartInfo.toolbarShow : true
                            },
                            events: {
                                // beforeMount: function (chartContext, config) {
                                //     console.log(chartContext, config);
                                // },
                                zoomed: function (chartContext, {
                                    xaxis
                                }) {
                                    if (chartContext.opts.chart.type == "bar") {
                                        let total = 0;
                                        chartContext.opts.series[0].data.forEach((d) => {
                                            if ((moment(d[0]).isAfter(xaxis.min) && moment(d[0]).isBefore(xaxis.max)) || (xaxis.min == undefined && xaxis.max == undefined)) {
                                                total = total + d[1];
                                            }
                                        });
                                        chartContext.updateOptions({
                                            title: {
                                                text: chartContext.opts.title.text.replace(/[\d]+/, total)
                                            }
                                        });
                                    } else {
                                        //area
                                        let firstV = 0;
                                        let lastV = 0;
                                        chartContext.opts.series[0].data.forEach((d) => {
                                            if ((moment(d[0]).isAfter(xaxis.min) && moment(d[0]).isBefore(xaxis.max)) || (xaxis.min == undefined && xaxis.max == undefined)) {
                                                if (firstV == 0) {
                                                    firstV = d[1];
                                                }
                                                lastV = d[1];
                                            }
                                        });
                                        let percent = formatData('number', (lastV - firstV) / firstV * 100);
                                        if (percent > 0) {
                                            percent = `+${percent}`;
                                        }
                                        chartContext.updateOptions({
                                            title: {
                                                text: chartContext.opts.title.text.replace(/[+|-]?[0-9.]+/, percent)
                                            }
                                        });
                                    }

                                }
                            }
                        },
                        fill: fillChart,
                        dataLabels: dataLabels,
                        markers: markersChart,
                        // markers: {
                        //     size: 0,
                        // },
                        title: {
                            text: this.$attrs.chartInfo.titleHide ? undefined : chartTitle,
                            align: 'left'
                        },
                        subtitle: {
                            // text: this.$attrs.chartInfo.chartSubTitle || undefined,
                            // align: 'right',
                            // offsetY: 330,
                            // style: {
                            //     color: undefined,
                            //     fontSize: '12px',
                            //     fontFamily: 'Helvetica, Arial, sans-serif',
                            //     fontWeight: 'bold',
                            //     cssClass: 'apexcharts-yaxis-title',
                            // },
                        },
                        stroke: strokeChart,
                        yaxis: {
                            // tickAmount: this.$attrs.chartInfo.tickAmount || 4,
                            forceNiceScale: this.$attrs.chartInfo.forceNiceScale || true,
                            min: this.$attrs.chartInfo.minY || 0,
                            max: this.$attrs.chartInfo.maxY || undefined,
                            labels: {
                                show: true,
                                formatter: function (val) {
                                    return val != undefined ? val.toFixed(0) : '';
                                },
                            },
                            title: {
                                // text: this.$attrs.chartInfo.chartSubTitle,
                            },
                        },
                        xaxis: {
                            type: this.$attrs.chartInfo.xaxisType != undefined ? this.$attrs.chartInfo.xaxisType : "datetime",
                            min: minX,
                            max: maxX,
                            title: {
                                // text: this.$attrs.chartInfo.chartSubTitle,
                                // ofsetY: 10,
                                // offsetX: 200
                            },
                            labels: {
                                datetimeUTC: false,
                                // formatter: function (val, timestamp) {
                                //     // return opts.dateFormatter(new Date(timestamp)).format("dd MMM");
                                //     // console.log(this.$attrs.chartInfo.title, opts);
                                //     return moment(timestamp).format("DD/MM/yyyy");
                                // }
                                datetimeFormatter: datetimeFormatter
                            },
                            axisBorder: {
                                show: true,
                                color: '#757575'
                            },
                            axisTicks: {
                                show: false
                            },
                            // tickAmount: 6,

                        },
                        tooltip: tooltip,
                        // annotations: {
                        //     yaxis: this.$attrs.chartInfo.annotations
                        // }
                    }
                };
            }
            return chartInfo;
        }
    },
    methods: {
        updateData: function (t, unit) {
            if (t) {
                this.$refs.chart.zoomX(
                    moment().subtract(t, unit).toDate().getTime(),
                    moment().toDate().getTime()
                );
            } else {
                this.$refs.chart.resetSeries();
            }
        },
        colorMe: function (modifier) {
            const colorMe = this.$attrs.chartInfo.color;
            return colors[colorMe][modifier];
        },
        toUpdateChart: function (item) {
            // this.filterOptionSelected2 = item;
            this.$emit('toUpdateChart', {
                mod: this.mod,
                filterOptionSelected: item,
                fromLoadChart: true
            });
        }
    }
};
</script>
